import { useState } from "react";
import {
  ExistingFile,
  NewOrExistingFile,
} from "../../../shared/types/newOrExistingFile";

const normalizeImageName = (url: string, index: number) =>
  url.split(/[?#]/)[0]?.split("/").pop() || `Image ${index + 1}`;

const buildModalImages = (images: string[]) =>
  images.map<ExistingFile>((url, index) => ({
    type: "existing",
    rotation: 0,
    file: {
      id: `${url}-${index}`,
      url,
      name: normalizeImageName(url, index),
      size: 0,
    },
  }));

export const useAddImagesModal = (initialImages: string[]) => {
  const [addImagesModalOpen, setAddImagesModalOpen] = useState(false);

  const [modalImages, setModalImages] = useState<NewOrExistingFile[]>(() =>
    buildModalImages(initialImages)
  );

  return {
    addImagesModalOpen,
    setAddImagesModalOpen,
    modalImages,
    setModalImages,
  };
};
